type Point = { x: number; y: number };

/** A marquee may begin in the gutter or be dragged in any direction. */
export function editorMarqueeContains(point: Point, start: Point, end: Point) {
  return point.x >= Math.min(start.x, end.x) && point.x <= Math.max(start.x, end.x)
    && point.y >= Math.min(start.y, end.y) && point.y <= Math.max(start.y, end.y);
}
